/**
 * Configuration Schema and Type Guards
 * Lightweight validation helpers without heavy dependencies
 */

import type { Environment } from "./types";

/**
 * Check if a string is a valid environment value
 */
export function isValidEnvironment(env: string): env is Environment {
  return env === "dev" || env === "stage" || env === "prod";
}

/**
 * Check if a string is a valid HTTP/HTTPS URL
 */
export function isValidUrl(url: string): boolean {
  if (!url || typeof url !== "string") {
    return false;
  }
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}

/**
 * Check if a value is a non-negative integer
 */
export function isNonNegativeInteger(value: unknown): value is number {
  return typeof value === "number" && Number.isInteger(value) && value >= 0;
}
